<template>

  <v-container class="global-margin" >

    <v-card>

      <v-btn
          absolute
          dark
          rounded
          top
          left
          color="primary"
          @click="goBack()"
      >
        NATRAG
      </v-btn>
    </v-card>

    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <div class="print-credentials">
          <img src="@/assets/img/header.png/" class="w-100" />
          <!-- <h6 class="text-right mt-1">Mostar, {{$date}} </h6> -->

          <div class="d-flex mt-3">
            <p class="text-right mb-0">Poštovani/a {{$route.query.full_name}},<br/></p>
          </div>

          <p class="mt-3">
            dostavljamo Vam korisničke podatake kojim se omogućava pristup SUMIT e-dnevniku
          </p>

          <p class="mt-3">Vaši korisnički podaci su:</p>

          <div class="d-flex justify-content-center w-100 mt-3 text-center">
            <div style="border: 1px solid black;" class="p-3 centar">
              <p class="text-center">Korisnička ime: <b> <!--  {{$user['uid']}} -->{{$route.query.username}}</b></p>
              <p class="text-center mb-0">Zaporka: <b> {{$route.query.password}}<!-- {{$password}} --></b></p>
            </div>
          </div>

          <p class="mt-3">Korisničke podatke, korisničku oznaku i zaporku, treba unositi doslovno onako kako su napisani i pri tome paziti na velika i mala slova.</p>

          <p class="mt-3 "></p>

          <p class="mt-3" >Više informacija na:
            <b><a href="https://skole.sum.ba" target="blank" style="text-decoration:none">skole.sum.ba</a></b>
          </p>

          <div style="margin-top:250px">
            <div class="row mt-2 footer">
              <div class="col col-md-8">
                <p><b>Mail: </b>podrska@skole.sum.ba</p>
                <p><b>Web: </b>https://skole.sum.ba </p>
                <p><b>Adresa: </b>Trg hrvatskih velikana 1, 88000 Mostar, BiH</p>
              </div>
            </div>
          </div>
        </div>


        <div class="footer-poravnanje">

          <img src="@/assets/img/sum-grey.svg/" class="w-100" />

        </div>

      </v-col>
    </v-row>


  </v-container>

</template>

<script>
// import {serverBus} from "../main";
export default {
  name: 'PrintParent',
  mounted() {
    setTimeout(() => {window.print();}, 500)
  },
  created() {

    // this.email = this.$route.query.email
    // this.pw = this.$route.query.password
    // console.log(this.user)
    // console.log(this.pw)
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    }
  },
  data() {
    return {
      username: '',
      pw: ''
    }
  }
}

</script>


<style lang="scss">


h1, h2, h3, h4, h5, h6 {
  font-family: 'DejaVu Sans', sans-serif !important;
}

.print-credentials .footer p {
  margin-bottom: 0.25rem;
}
/* Print */
@media print {
  .print-credentials p {
    font-size: 1.3rem;
  }

  .print-credentials h5 {
    font-size: 1.4rem;
  }

  .print-credentials h6 {
    font-size: 1.3rem;
  }

  .print-credentials li {
    font-size: 1.3rem;
  }

  .print-credentials .mt-3 {
    margin-top: 2.5rem !important;
  }

  .print-credentials .my-3 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .print-show {
    display: block !important;
  }

  .print-hide,
  .v-btn {
    display: none !important;
  }

  .print-hide,
  .v-dialog {
    display: none !important;
  }

  .main-content {
    padding: 0 !important;
  }

  .print-show-flex {
    display: flex !important;
  }
  .centar{

    margin: auto;
    width: 50%;
    padding: 10px;
  }
  .footer-poravnanje
  {
    text-align: center;
    margin-top: 65px;

  }
}
</style>
